import http from "@/js/http";
import { openMsgToast } from "@/js/message";
const ossUrl = "https://resource.yingyutifen.cn/a2504/";
export function textToPlayAudio(text: string, callback: any): void {
  const nonChineseText = text.replace(/[\u4e00-\u9fa5\u3000-\u303f\uff00-\uffef]/g, "");
  http.post("/tts/speak", { text: nonChineseText }).then(async (res) => {
    if (res.data.code === 9000) {
      if (res.data.tts) {
        const audioUrl = ossUrl + res.data.tts;
        callback(audioUrl);
      } else {
        callback("");
      }
    } else {
      await openMsgToast(res.data.message);
    }
  });
}
